// import jwtDecode from "jwt-decode"; // Install with `npm install jwt-decode`
import { jwtDecode } from "jwt-decode"; // Named import
import { generalApiRequest } from "../api/apiIndex";

export function isTokenExpired(token) {
  // console.log("now logging from decode side-----------");
  // console.log(token);

  if (!token) {
    return true;
  }
  // console.log("going past null token");

  try {
    // Remove whitespace + wrapping quotes
    token = token
      .toString()
      .trim()
      .replace(/^"+|"+$/g, "");

    const decoded = jwtDecode(token);

    // console.log("following decoded");
    // console.log(decoded);

    // token has no exp at all → treat as expired to avoid security risk
    if (!decoded.exp) return true;

    const currentTime = Math.floor(Date.now() / 1000);
    // console.log(decoded.exp);
    // console.log(currentTime);

    return decoded.exp < currentTime;
  } catch (error) {
    console.error("Invalid token format:", error);
    return true; // decode failure = expired
  }
}

// export function isTokenExpired(token) {
//   if (!token || token == null || token == "") {
//     // console.log("invalidating from this point");

//     // console.log(token);

//     return true; // No token means expired
//   }

//   try {
//     const decoded = jwtDecode(token);
//     const currentTime = Math.floor(Date.now() / 1000); // Convert to seconds
//     // console.log(decoded.exp);

//     return decoded.exp < currentTime; // Expired if `exp` is less than now
//   } catch (error) {
//     console.error("Invalid token:", error);
//     return true; // Treat as expired if decoding fails
//   }
// }

export function getTokenRemainingTime(tokenCreatedAtUtc) {
  const tokenCreatedTime = new Date(tokenCreatedAtUtc).getTime();
  const currentTime = new Date().getTime();

  const tokenLifetimeMs = 8 * 60 * 60 * 1000; // 2 hours in milliseconds
  const expiryTime = tokenCreatedTime + tokenLifetimeMs;

  const remainingTimeMs = expiryTime - currentTime;

  // Convert to minutes, round down
  const remainingMinutes = Math.floor(remainingTimeMs / (60 * 1000));

  const time = remainingMinutes > 0 ? remainingMinutes : 0;
  return time;
}
// const isLoggedIn = this.$store.getters.isAuthenticated;
let tokenRenewalTimeout = null;

export async function get_new_token(store) {
  const token_time_to_expiry = getTokenRemainingTime(store.state.time);

  if (tokenRenewalTimeout) {
    clearTimeout(tokenRenewalTimeout);
  }

  console.log(token_time_to_expiry);

  if (token_time_to_expiry < 114) {
    tokenRenewalTimeout = setTimeout(() => {
      if (getTokenRemainingTime(store.state.time) < 114) {
        console.log("calling...");
        sidecall(store);
      } else {
        console.log("thrown away");
      }
    }, 1 * 60 * 1000);
  } else {
    console.log("not greater");
  }

  return "success";
}

export async function sidecall() {
  var body = {};
  const res = await generalApiRequest("renew_auth_token", "post", body, 1);
  return res;
  // var new_tok = res.data;
  // var new_time = res.ttime;
  // console.log(res);

  // Dispatch token update
  // store.dispatch("updateToken", new_tok);
  // store.dispatch("updateTime", new_time);
}
